import React, { memo } from "react";
import {
    Box,
    Stack,
    TextField,
} from "@mui/material";
import { useFormikContext } from "formik";
import SharedAttachments from "../../../../../Components/SharedAttachments";
import employeeManagementStyles from "../../../../../styles/employeeManagement.styles";

// --- Constants ---
const ALLOWED_EXTENSIONS = [
    ".jpeg", ".jpg", ".gif", ".png", ".xls", ".xlsx", 
    ".doc", ".docx", ".pdf", ".txt", ".xps"
];

// --- Subcomponents ---
const PillLabel = memo(({ label }) => (
  <Box sx={employeeManagementStyles.pillLabel}>
    {label}
  </Box>
));

const NotesAndAttachments = ({ token, showPreview = true }) => {
    const { values, handleChange } = useFormikContext();

    return (
        <Stack spacing={1} sx={employeeManagementStyles.notesAndAttachmentsStack}>
            
            {/* Notes Section */}
            <Box>
                <PillLabel label="Notes" />
                <TextField
                    name="notes"
                    multiline
                    fullWidth
                    rows={2}
                    value={values.notes || ""}
                    onChange={handleChange}
                    sx={employeeManagementStyles.notesTextField}
                />
            </Box>

            {/* Attachments Section */}
            <Box>
                <PillLabel label="Attachment(s)" />
                <SharedAttachments
                    token={token}
                    showPreview={showPreview}
                    documentType="Employee Document"
                    allowedExtensions={ALLOWED_EXTENSIONS}
                />
            </Box>
        </Stack>
    );
};

export default memo(NotesAndAttachments);
